import { Button, DialogContentText } from '@mui/material';
import { StyledDialog, StyledDialogActions, StyledDialogContent, StyledDialogTitle } from './ConfirmationModal.styles';
import { ConfirmationModalProps } from './ConfirmationModal.types';

const ConfirmationModal = ({
  open,
  title,
  message,
  highlightedText,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  onConfirm,
  onCancel,
}: ConfirmationModalProps) => (
  <StyledDialog
    open={open}
    onClose={onCancel}
    aria-labelledby="confirmation-modal-title"
    aria-describedby="confirmation-modal-description">
    <StyledDialogTitle id="confirmation-modal-title">{title}</StyledDialogTitle>
    <StyledDialogContent>
      <DialogContentText id="confirmation-modal-description">
        {message}
        {highlightedText && <strong> {highlightedText}</strong>}
        {highlightedText && '?'}
      </DialogContentText>
    </StyledDialogContent>
    <StyledDialogActions>
      <Button onClick={onCancel} color="inherit">
        {cancelButtonText}
      </Button>
      <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
        {confirmButtonText}
      </Button>
    </StyledDialogActions>
  </StyledDialog>
);

export default ConfirmationModal;
